import { type ReactNode } from 'react';
import type { TeamMember } from '../types';
import { TeamMemberCard } from './team-member-card';

const GRID_DEFAULT =
  'grid-cols-2 gap-md sm:grid-cols-3 lg:grid-cols-4 lg:gap-base xl:grid-cols-5';
const GRID_COMPACT =
  'grid-cols-3 gap-sm sm:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6';
// Pre-collectors render as one horizontal scroll row; cell widths match
// GRID_COMPACT so card sizes stay pixel-identical to the grid layout.
const ROW_CONTAINER =
  'mt-md -mx-base flex snap-x snap-mandatory gap-sm overflow-x-auto px-base py-xs [&::-webkit-scrollbar]:hidden';
const ROW_CELL =
  'snap-start shrink-0 w-[calc((100%-16px)/3)] sm:w-[calc((100%-24px)/4)] lg:w-[calc((100%-32px)/5)] xl:w-[calc((100%-40px)/6)]';

export type LayoutProps = {
  members: TeamMember[];
  onSelect?: (id: string) => void;
};

function Card(p: {
  m: TeamMember;
  onSelect?: (id: string) => void;
}): ReactNode {
  return (
    <TeamMemberCard
      member={p.m}
      {...(p.onSelect && { onSelect: p.onSelect })}
    />
  );
}

export function GridLayout(p: LayoutProps & { compact: boolean }): ReactNode {
  return (
    <div className={`mt-md grid ${p.compact ? GRID_COMPACT : GRID_DEFAULT}`}>
      {p.members.map((m) => (
        <Card key={m.id} m={m} {...(p.onSelect && { onSelect: p.onSelect })} />
      ))}
    </div>
  );
}

export function RowLayout(p: LayoutProps): ReactNode {
  return (
    <div className={ROW_CONTAINER}>
      {p.members.map((m) => (
        <div key={m.id} className={ROW_CELL}>
          <Card m={m} {...(p.onSelect && { onSelect: p.onSelect })} />
        </div>
      ))}
    </div>
  );
}
